import api from '../config/axiosConfig';

export const ReportesService = {
    getSchema: async ({ token, table }) => {
        try {
            const response = await api.get(`/reportes/schema/${table}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReportesService.getSchema:', error);
            throw error;
        }
    },

    exportarDatos: async ({ token, table, whereSql }) => {
        try {
            const response = await api.post('/reportes/exportar',
                { table, whereSql },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        } catch (error) {
            console.error('Error en ReportesService.exportarDatos:', error);
            throw error;
        }
    },
    saveConfig: async ({ token, data }) => {
        try {
            const response = await api.post(
                `/reportes/save-config`,
                data,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error en saveConfig service:", error.response?.data || error.message);
            throw error;
        }
    },

    getSavedConfigs: async ({ token }) => {
        const response = await api.get(`/reportes/saved-configs`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    },
    getConfigurationList: async ({ token, pagina = 1, pageSize = 20, nombre = '' }) => {
        try {
            const response = await api.get('/reportes', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, nombre },
            });

            return {
                reportes: response.data.reportes || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ReportesService.getConfigurationList:', error);
            throw error;
        }
    },
    execute: async (id, token, page = 1, limit = 20) => {
        try {
            const response = await api.get(`/reportes/execute/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { page, limit } // Se envían como ?page=1&limit=20
            });
            return response.data;
        } catch (error) {
            console.error('Error en ReportesService.execute:', error);
            throw error;
        }
    },
    exportToExcel: async (id, token) => {

        const response = await api.post(`/reportes/exportar/${id}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: 'blob',
        });


        return response.data;
    },
    getConfigById: async (id, token) => {
        try {
            const response = await api.get(`/reportes/config/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error) {
            console.error("Error en getConfigById:", error);
            throw error; 
        }
    },
    updateConfig: async (id, token, data) => {
        try {
            const response = await api.put(`/reportes/config/${id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error("Error en updateConfig:", error);
            throw error;
        }
    }
};